import { ReactComponent as CancelIcon } from "assets/images/cancel.svg";
import { ReactComponent as CheckIcon } from "assets/images/check.svg";
import { Badge } from "react-bootstrap";

interface ModalIconProps {
  type: "success" | "danger";
}

const ModalIcon = ({ type }: ModalIconProps) => {
  return (
    <div className="text-center modal-delete-icon">
      <Badge
        bg={type}
        className="rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width: 100, height: 100 }}
      >
        {type === "success" ? (
          <CheckIcon width={40} height={40} />
        ) : (
          <CancelIcon width={40} height={40} />
        )}
      </Badge>
    </div>
  );
};

export default ModalIcon;
